import type { IOpportunity } from '~/types/opportunity/models'

/**
 * The two-line "Stage / Status" cell the opportunity cards render.
 *
 * ⚠ BUILT IN TWO PLACES, ON PURPOSE. `Opportunity()` builds it on setup, and
 * the status ladder in `propagateOMSServicesData` rebuilds it after writing
 * `opportunity.status`. The ladder runs AFTER setup, so without the rebuild the
 * header showed the status as loaded until a browser refresh.
 */
export function StageStatusDescr(opportunity: IOpportunity): string {
  return `${opportunity.stage?.label ?? '(Will Be Stage)'}\n${
    opportunity.status?.label
  }`
}
